<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_from"
          :label="$t('fields.date_from')"
          :clearable="true"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_to"
          :label="$t('fields.date_to')"
          :clearable="true"
        />
      </v-flex>
      <v-flex xs2 class="mt-6 ml-2">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          :label="$t('fields.propagandist')"
        />
      </v-flex>
      <v-flex xs1 class="mt-6 ml-2">
        <v-text-field
          v-model="filters.order_id"
          label="N. Ordine"
          clearable
          type="number"
        />
      </v-flex>
      <v-spacer></v-spacer>

        <v-btn
          @click="createOrder()"
          class="primary mr-2"
        >{{ $t("NEW_ORDER") }}
        </v-btn>

    </v-row>
    </v-container>
    <v-row>
    <v-col
      cols="12"
    >

    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      show-select
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:[`item.propagandist`]="{ item }">
        {{ item.surname }} {{ item.name }}
      </template>

      <template v-slot:[`item.date_from`]="{ item }">
        {{ item.date_from | utcTime('DD/MM/YYYY HH:mm:ss') }}
      </template>

      <template v-slot:[`item.date_to`]="{ item }">
        {{ item.date_to | utcTime('DD/MM/YYYY HH:mm:ss') }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
           <v-layout wrap>
            <v-flex>
                <v-btn
                  icon
                  @click="downloadCsv(csvFilename(item), item.csv)"
                >
                    <v-icon>cloud_download</v-icon>
                </v-btn>
              </v-flex>
           </v-layout>
      </template>

    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchOrders"
    />
    </v-col>
    </v-row>
  </div>
  </v-flex>
</template>
<script>

  import { mapActions, mapGetters } from 'vuex';

  import { ordersService } from '../../../utils/services/orders.service';
  import InputDataPicker from '../../../components/shared/Inputs/InputDataPicker.vue';
  import PropagandistSelect from '../../../components/shared/Vselects/PropagandistSelect.vue';
  import OrderModal from '../../../components/modals/Orders/OrderModal.vue';
  import Paginator from '../../../components/shared/Paginator';
  import { routeNames } from '../../../config/router/routeNames';

  const BOOKED_ORDER_PERMISSION = 'manage booked orders';

  export default {
    name: 'CampaignReportBookedOrder',
    components: {
      InputDataPicker,
      PropagandistSelect,
      Paginator,
    },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['orders.created_at'],
        },

        headers: [
          { text: 'N. Ordine', value: 'id' },
          { text: this.$t('fields.date_from'), value: 'date_from' },
          { text: this.$t('fields.date_to'), value: 'date_to' },
          { text: this.$t('fields.propagandist'), value: 'propagandist', sortable: false },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          date_from: null,
          date_to: null,
          propagandist_id: 0,
          order_id: null,
        },
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      permissionsLoaded() {
        const { permissions } = this.$store.state.user;
        return !!(permissions && permissions.permissions);
      },
      canManageBookedOrders() {
        return this.permissionsLoaded && this.can(BOOKED_ORDER_PERMISSION);
      },
      requestFilters() {
        const filters = {
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
          propagandist_id: this.filters.propagandist_id,
          order_id: this.filters.order_id,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      ...mapGetters('user', ['currentUser']),

      async showOrderModal() {
        this.showModal({
          component: OrderModal,
            data: {
              stored: {},
          },
          options: {
            title: this.$t('ORDER'),
            onSave: (
              form,
              errorBag,
            ) => ordersService.create(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch((error) => {
              this.handleError(error, errorBag);
            })
            .finally(() => {
              this.fetchOrders(1);
              this.hideModal({});
            }),
          },
        });
      },

      createOrder() {
        if (this.currentUser.user.is_propagandist) {
          this.showOrderConfirm();
        } else {
          this.showOrderModal();
        }
      },

      async showOrderConfirm() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return ordersService.create({ propagandist_id: this.currentUser.user.id })
              .then(() => {
                this.fetchOrders(1);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
                this.hideModal({});
              });
            },
          });
      },

      csvFilename(order) {
        const { utcTime } = this.$options.filters;
        const format = 'YYYY-MM-DD HH:mm:ss';
        return `${utcTime(order.date_from, format)} - ${utcTime(order.date_to, format)}`;
      },

      downloadCsv(filename, content) {
        const link = document.createElement('a');
        const filelog = new Blob([content], { type: 'text/plain' });
        link.href = URL.createObjectURL(filelog);
        link.download = `order ${filename }.txt`;
        link.click();
        URL.revokeObjectURL(link.href);
      },

      // I permessi arrivano in modo asincrono: finche' non sono caricati non si
      // decide nulla, poi chi non ha il permesso torna all'elenco dei report.
      checkAccess() {
        if (!this.permissionsLoaded) return;
        if (!this.canManageBookedOrders) {
          this.$router.replace({ name: routeNames.CAMPAIGN_REPORT });
          return;
        }
        this.fetchOrders(1);
      },

      async fetchOrders(forcePage) {
        if (!this.canManageBookedOrders) return Promise.resolve();
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return ordersService.propagandistReportBookedOrders({
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

    },
    created() {
      if (this.$route.query.order_id) {
        this.filters.order_id = this.$route.query.order_id;
      }
      this.checkAccess();
    },
    watch: {
      permissionsLoaded() {
        this.checkAccess();
      },
      filters: {
        deep: true,
        handler() {
          this.fetchOrders(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchOrders(1);
          }
        },
      },

    },
  };
</script>
